import styled from 'styled-components';
import { ButtonLined } from '@finect/tabular-core/ButtonLined';
export var ButtonActionComparison = styled(ButtonLined).withConfig({
  displayName: "Button__ButtonActionComparison",
  componentId: "sc-4y5ia1-0"
})(["display:inline-flex;margin-left:12px;svg{margin-right:4px;vertical-align:middle;}"]);